<script setup lang="ts">
import VLazyImage from 'v-lazy-image'
import { computed } from 'vue'
import type { Image } from '../../../types'

interface Props {
  image: Image
}

const props = defineProps<Props>()
const alt = computed<string>(() => props.image?.alt?.replace(/\..*/, '') || '')
</script>

<template>
  <VLazyImage
    :caption="image.caption"
    :src="image.src"
    :srcset="image.srcset"
    :alt="alt"
  />
</template>
